import { render, staticRenderFns } from "./RawMaterials.vue?vue&type=template&id=61e3c63c"
import script from "./RawMaterials.vue?vue&type=script&lang=js"
export * from "./RawMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports